import { apiClient } from "../../../api/client";
import * as ActionType from "./bank.type";
import { setToast } from "../../../util/toast";

export const getBank = () => async (dispatch) => {
  const res = await apiClient.get("bank/getAllBank");
  if (res.ok) {
    dispatch({ type: ActionType.GET_BANK, payload: res.data?.bankList });
  } else {
    console.log(res.message);
  }
};

export const createBank = (data) => async (dispatch) => {
  const res = await apiClient.post("bank/createBank", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.CREATE_BANK, payload: res.data?.bank });
    setToast("success", "Bank created successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const updateBank = (data) => async (dispatch) => {
  const res = await apiClient.patch("bank/updateBank", data);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.UPDATE_BANK, payload: res.data?.bank });
    setToast("success", "Bank updated successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};

export const deleteBank = (id) => async (dispatch) => {
  const res = await apiClient.delete(`bank/deleteBank?bankId=${id}`);
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_BANK, payload: id });
    setToast("success", "Bank deleted successfully");
  } else {
    setToast("error", res.data?.message || res.message);
  }
};
